import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export function photoUrl(p) {
  if (!p) return "";
  return p.startsWith("http") ? p : `${BACKEND_URL}${p}`;
}

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Bir hata oluştu. Lütfen tekrar deneyin.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  return String(detail);
}

export async function uploadFiles(files) {
  const paths = [];
  for (const f of files) {
    const fd = new FormData();
    fd.append("file", f);
    const { data } = await api.post("/upload", fd);
    paths.push(data.path);
  }
  return paths;
}
